import { createElement } from 'react';
import { feFactory } from 'fela-bindings';

import FelaComponent from './FelaComponent';

export default feFactory(createElement, FelaComponent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/fe.js
// module id = 1195
// module chunks = 0